import { Col, Container, Row } from "react-bootstrap";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { useTranslation } from "react-i18next";

export default function GreatPlaceToWork(){
    const { t } = useTranslation();

    return(
        <article id="gptw">
            <section className="greatplacetowork">
                <Container>
                    <Row>
                        <Col>
                            <div class="gptw-logo">
                                <LazyLoadImage src={require("../../images/gptw_logo.png")} />
                            </div>
                        </Col>
                    </Row>
                    <Row className="info-container-row">
                        <Col md={6}>
                            <div className="gptw-highlights">
                                <ul>
                                    <li>
                                        <div className="number-highlight">
                                            <div className="number">96%</div>
                                        </div>
                                        <div className="highlight-description">
                                            {t(`lifeatcentrico.gptw.point1`)}
                                        </div>
                                    </li>
                                    <li>
                                        <div className="number-highlight">
                                            <div className="number">97%</div>
                                        </div>
                                        <div className="highlight-description">
                                        {t(`lifeatcentrico.gptw.point2`)}
                                        </div>
                                    </li>
                                    <li>
                                        <div className="number-highlight">
                                            <div className="number">94%</div>
                                        </div>
                                        <div className="highlight-description">
                                        {t(`lifeatcentrico.gptw.point3`)}
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </Col>
                        <Col md={6}>
                            <div className="chart-container">
                                <div className="svg-item">
                                    <svg width="100%" height="100%" viewBox="0 0 40 40" className="donut">
                                        <circle className="donut-hole" cx="20" cy="20" r="15.91549430918954" fill="#fff"></circle>
                                        <circle className="donut-ring" cx="20" cy="20" r="15.91549430918954" fill="transparent" stroke-width="3.5"></circle>
                                        <circle className="donut-segment donut-segment-2" cx="20" cy="20" r="15.91549430918954" fill="transparent" stroke-width="3.5" stroke-dasharray="89 11" stroke-dashoffset="25"></circle>
                                        <g className="donut-text donut-text-1">
                                            <text y="50%" transform="translate(0, 2)">
                                                <tspan x="50%" text-anchor="middle" className="donut-percent">89%</tspan>   
                                            </text>
                                            <text y="60%" transform="translate(0, 2)">
                                                <tspan x="50%" text-anchor="middle" className="donut-data">{t(`lifeatcentrico.gptw.says`)}</tspan>   
                                            </text>
                                        </g>
                                    </svg>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </article>
    )
}